import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 20px;
    margin-top: 20px;
`;

export const LogoWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
`;

export const VigoLogo = styled.img``;

export const CopyrightWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
`;

export const CopyrightLine = styled.div`
    height: 1px;
    width: 100%;
    background-color: #dcdcdc;
`;

export const CopyrightText = styled.div`
    width: 100%;
    font-size: 16px;
    font-weight: lighter;
    color: #737373;
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: right;
`;
